"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainSearchPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var SearchPageBase_1 = require("./SearchPageBase");
var MainSearchFormPanel_1 = require("./MainSearchFormPanel");
var components_1 = require("@athena-portal/components");
var MainSearchPage = /** @class */ (function (_super) {
    __extends(MainSearchPage, _super);
    function MainSearchPage(props) {
        var _this = _super.call(this, props) || this;
        _this.validate = function (params) {
            if (!params.policyNumber && !params.vehicleRegistrationNumber &&
                !params.email && !params.phoneNumber) {
                var count = Object.values(params).filter(Boolean).length;
                if (count < 2) {
                    return {
                        valid: false,
                        message: "To search for a customer you must use at least:\n" +
                            "a) vehicle registration number\n" +
                            "b) policy number\n" +
                            "c) customer email address\n" +
                            "d) mobile number\n" +
                            "e) combination of any two search parameters"
                    };
                }
            }
            return { valid: true };
        };
        _this.onSearch = function () {
            _this.supportPortalService.getParties(__assign(__assign({}, _this.state.searchParameters), { limit: _this.state.limit, offset: _this.state.offset })).subscribe(function (searchResult) {
                _super.prototype.setState.call(_this, {
                    loading: false,
                    searchResult: searchResult,
                    noResultError: searchResult.count === 0
                });
            }, function () { return _super.prototype.setState.call(_this, { loading: false }); });
        };
        _this.logAgentActivity = function (reference) {
            _this.supportPortalService.logAgentActivity(reference, {
                action: "No Action",
                customer: "Account"
            }).subscribe();
        };
        _this.state = __assign(__assign({}, _this.state), { searchParameters: {
                firstName: "",
                lastName: "",
                dateOfBirth: "",
                postCode: "",
                email: "",
                vehicleRegistrationNumber: "",
                policyNumber: "",
                phoneNumber: "",
                productId: undefined
            } });
        return _this;
    }
    MainSearchPage.prototype.render = function () {
        var _this = this;
        var auth = this.authorize();
        if (auth) {
            return auth;
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MainSearchFormPanel_1.MainSearchFormPanel, { onSearch: this.handleSearch, onSearchParameterChange: function (parameter, value) {
                        var _a;
                        return _this.setState({
                            searchParameters: __assign(__assign({}, _this.state.searchParameters), (_a = {}, _a[parameter] = value, _a))
                        });
                    }, limit: this.state.limit, offset: this.state.offset }), this.renderPagination(), this.renderSpinner(), this.supportPortalTemplates.renderFooter()] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], MainSearchPage.prototype, "supportPortalService", void 0);
    MainSearchPage = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], MainSearchPage);
    return MainSearchPage;
}(SearchPageBase_1.SearchPageBase));
exports.MainSearchPage = MainSearchPage;
//# sourceMappingURL=MainSearchPage.js.map